/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EvaluateStateRequest } from '../models';
// @ts-ignore
import type { EvaluateStateResponse } from '../models';
// @ts-ignore
import type { ListNodeDiskRecommendationsResponse } from '../models';
// @ts-ignore
import type { NodeDiskRecommendation } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * EphemeralStorageAPIApi - axios parameter creator
 * @export
 */
export const EphemeralStorageAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * EvaluateState receives current state of node ephemeral storage and calculates what next state should be
         * @summary Evaluate node ephemeral storage state
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {EvaluateStateRequest} evaluateStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIEvaluateState: async (organizationId: string, clusterId: string, evaluateStateRequest: EvaluateStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('ephemeralStorageAPIEvaluateState', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('ephemeralStorageAPIEvaluateState', 'clusterId', clusterId)
            // verify required parameter 'evaluateStateRequest' is not null or undefined
            assertParamExists('ephemeralStorageAPIEvaluateState', 'evaluateStateRequest', evaluateStateRequest)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/ephemeral-storage:evaluate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a recommendation of an initial disk parameters for a given node template. Use node template name as ID
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeTemplateName Node template name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIGetNodeDiskRecommendation: async (organizationId: string, clusterId: string, nodeTemplateName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('ephemeralStorageAPIGetNodeDiskRecommendation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('ephemeralStorageAPIGetNodeDiskRecommendation', 'clusterId', clusterId)
            // verify required parameter 'nodeTemplateName' is not null or undefined
            assertParamExists('ephemeralStorageAPIGetNodeDiskRecommendation', 'nodeTemplateName', nodeTemplateName)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-templates/{nodeTemplateName}/disk-recommendation`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeTemplateName"}}`, encodeURIComponent(String(nodeTemplateName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns node-storage-agent installation script as plain text.
         * @summary Get node-storage-agent installation script
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {EphemeralStorageAPIInstallationScriptInstallationTypeEnum} [installationType] Type of installation the script will generate.
         * @param {boolean} [eksDisableKmsKeyPermissions] Controls if the resulting IAM role will have access too use KMS keys specified in node configurations of  the cluster for EBS encryption.
         * @param {Array<string>} [eksKmsKeyArns] List of KMS key ARNs the IAM role will have access to. If not specified, KMS keys from node configurations will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIInstallationScript: async (organizationId: string, clusterId: string, installationType?: EphemeralStorageAPIInstallationScriptInstallationTypeEnum, eksDisableKmsKeyPermissions?: boolean, eksKmsKeyArns?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('ephemeralStorageAPIInstallationScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('ephemeralStorageAPIInstallationScript', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/installation-script`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (installationType !== undefined) {
                localVarQueryParameter['installationType'] = installationType;
            }

            if (eksDisableKmsKeyPermissions !== undefined) {
                localVarQueryParameter['eks.disableKmsKeyPermissions'] = eksDisableKmsKeyPermissions;
            }

            if (eksKmsKeyArns) {
                localVarQueryParameter['eks.kmsKeyArns'] = eksKmsKeyArns;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of disk recommendations for the node root disk and ephemeral disks.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIListNodeDiskRecommendations: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('ephemeralStorageAPIListNodeDiskRecommendations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('ephemeralStorageAPIListNodeDiskRecommendations', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/disk-recommendations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EphemeralStorageAPIApi - functional programming interface
 * @export
 */
export const EphemeralStorageAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EphemeralStorageAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * EvaluateState receives current state of node ephemeral storage and calculates what next state should be
         * @summary Evaluate node ephemeral storage state
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {EvaluateStateRequest} evaluateStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ephemeralStorageAPIEvaluateState(organizationId: string, clusterId: string, evaluateStateRequest: EvaluateStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluateStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ephemeralStorageAPIEvaluateState(organizationId, clusterId, evaluateStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EphemeralStorageAPIApi.ephemeralStorageAPIEvaluateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a recommendation of an initial disk parameters for a given node template. Use node template name as ID
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeTemplateName Node template name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ephemeralStorageAPIGetNodeDiskRecommendation(organizationId: string, clusterId: string, nodeTemplateName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeDiskRecommendation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ephemeralStorageAPIGetNodeDiskRecommendation(organizationId, clusterId, nodeTemplateName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EphemeralStorageAPIApi.ephemeralStorageAPIGetNodeDiskRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns node-storage-agent installation script as plain text.
         * @summary Get node-storage-agent installation script
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {EphemeralStorageAPIInstallationScriptInstallationTypeEnum} [installationType] Type of installation the script will generate.
         * @param {boolean} [eksDisableKmsKeyPermissions] Controls if the resulting IAM role will have access too use KMS keys specified in node configurations of  the cluster for EBS encryption.
         * @param {Array<string>} [eksKmsKeyArns] List of KMS key ARNs the IAM role will have access to. If not specified, KMS keys from node configurations will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ephemeralStorageAPIInstallationScript(organizationId: string, clusterId: string, installationType?: EphemeralStorageAPIInstallationScriptInstallationTypeEnum, eksDisableKmsKeyPermissions?: boolean, eksKmsKeyArns?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ephemeralStorageAPIInstallationScript(organizationId, clusterId, installationType, eksDisableKmsKeyPermissions, eksKmsKeyArns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EphemeralStorageAPIApi.ephemeralStorageAPIInstallationScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of disk recommendations for the node root disk and ephemeral disks.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ephemeralStorageAPIListNodeDiskRecommendations(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNodeDiskRecommendationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ephemeralStorageAPIListNodeDiskRecommendations(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EphemeralStorageAPIApi.ephemeralStorageAPIListNodeDiskRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EphemeralStorageAPIApi - factory interface
 * @export
 */
export const EphemeralStorageAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EphemeralStorageAPIApiFp(configuration)
    return {
        /**
         * EvaluateState receives current state of node ephemeral storage and calculates what next state should be
         * @summary Evaluate node ephemeral storage state
         * @param {EphemeralStorageAPIApiEphemeralStorageAPIEvaluateStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIEvaluateState(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIEvaluateStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvaluateStateResponse> {
            return localVarFp.ephemeralStorageAPIEvaluateState(requestParameters.organizationId, requestParameters.clusterId, requestParameters.evaluateStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a recommendation of an initial disk parameters for a given node template. Use node template name as ID
         * @param {EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIGetNodeDiskRecommendation(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeDiskRecommendation> {
            return localVarFp.ephemeralStorageAPIGetNodeDiskRecommendation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeTemplateName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns node-storage-agent installation script as plain text.
         * @summary Get node-storage-agent installation script
         * @param {EphemeralStorageAPIApiEphemeralStorageAPIInstallationScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIInstallationScript(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIInstallationScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.ephemeralStorageAPIInstallationScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.installationType, requestParameters.eksDisableKmsKeyPermissions, requestParameters.eksKmsKeyArns, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of disk recommendations for the node root disk and ephemeral disks.
         * @param {EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ephemeralStorageAPIListNodeDiskRecommendations(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListNodeDiskRecommendationsResponse> {
            return localVarFp.ephemeralStorageAPIListNodeDiskRecommendations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ephemeralStorageAPIEvaluateState operation in EphemeralStorageAPIApi.
 * @export
 * @interface EphemeralStorageAPIApiEphemeralStorageAPIEvaluateStateRequest
 */
export interface EphemeralStorageAPIApiEphemeralStorageAPIEvaluateStateRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIEvaluateState
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIEvaluateState
     */
    readonly clusterId: string

    /**
     * 
     * @type {EvaluateStateRequest}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIEvaluateState
     */
    readonly evaluateStateRequest: EvaluateStateRequest
}

/**
 * Request parameters for ephemeralStorageAPIGetNodeDiskRecommendation operation in EphemeralStorageAPIApi.
 * @export
 * @interface EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendationRequest
 */
export interface EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendation
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendation
     */
    readonly clusterId: string

    /**
     * Node template name.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendation
     */
    readonly nodeTemplateName: string
}

/**
 * Request parameters for ephemeralStorageAPIInstallationScript operation in EphemeralStorageAPIApi.
 * @export
 * @interface EphemeralStorageAPIApiEphemeralStorageAPIInstallationScriptRequest
 */
export interface EphemeralStorageAPIApiEphemeralStorageAPIInstallationScriptRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIInstallationScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIInstallationScript
     */
    readonly clusterId: string

    /**
     * Type of installation the script will generate.
     * @type {'INSTALLATION_TYPE_UNSPECIFIED' | 'IRSA_INSTALLATION' | 'NODE_ROLE_INSTALLATION'}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIInstallationScript
     */
    readonly installationType?: EphemeralStorageAPIInstallationScriptInstallationTypeEnum

    /**
     * Controls if the resulting IAM role will have access too use KMS keys specified in node configurations of  the cluster for EBS encryption.
     * @type {boolean}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIInstallationScript
     */
    readonly eksDisableKmsKeyPermissions?: boolean

    /**
     * List of KMS key ARNs the IAM role will have access to. If not specified, KMS keys from node configurations will be used.
     * @type {Array<string>}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIInstallationScript
     */
    readonly eksKmsKeyArns?: Array<string>
}

/**
 * Request parameters for ephemeralStorageAPIListNodeDiskRecommendations operation in EphemeralStorageAPIApi.
 * @export
 * @interface EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendationsRequest
 */
export interface EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendationsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendations
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendations
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendations
     */
    readonly pageCursor?: string
}

/**
 * EphemeralStorageAPIApi - object-oriented interface
 * @export
 * @class EphemeralStorageAPIApi
 * @extends {BaseAPI}
 */
export class EphemeralStorageAPIApi extends BaseAPI {
    /**
     * EvaluateState receives current state of node ephemeral storage and calculates what next state should be
     * @summary Evaluate node ephemeral storage state
     * @param {EphemeralStorageAPIApiEphemeralStorageAPIEvaluateStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EphemeralStorageAPIApi
     */
    public ephemeralStorageAPIEvaluateState(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIEvaluateStateRequest, options?: RawAxiosRequestConfig) {
        return EphemeralStorageAPIApiFp(this.configuration).ephemeralStorageAPIEvaluateState(requestParameters.organizationId, requestParameters.clusterId, requestParameters.evaluateStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a recommendation of an initial disk parameters for a given node template. Use node template name as ID
     * @param {EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EphemeralStorageAPIApi
     */
    public ephemeralStorageAPIGetNodeDiskRecommendation(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIGetNodeDiskRecommendationRequest, options?: RawAxiosRequestConfig) {
        return EphemeralStorageAPIApiFp(this.configuration).ephemeralStorageAPIGetNodeDiskRecommendation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeTemplateName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns node-storage-agent installation script as plain text.
     * @summary Get node-storage-agent installation script
     * @param {EphemeralStorageAPIApiEphemeralStorageAPIInstallationScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EphemeralStorageAPIApi
     */
    public ephemeralStorageAPIInstallationScript(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIInstallationScriptRequest, options?: RawAxiosRequestConfig) {
        return EphemeralStorageAPIApiFp(this.configuration).ephemeralStorageAPIInstallationScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.installationType, requestParameters.eksDisableKmsKeyPermissions, requestParameters.eksKmsKeyArns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of disk recommendations for the node root disk and ephemeral disks.
     * @param {EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EphemeralStorageAPIApi
     */
    public ephemeralStorageAPIListNodeDiskRecommendations(requestParameters: EphemeralStorageAPIApiEphemeralStorageAPIListNodeDiskRecommendationsRequest, options?: RawAxiosRequestConfig) {
        return EphemeralStorageAPIApiFp(this.configuration).ephemeralStorageAPIListNodeDiskRecommendations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EphemeralStorageAPIInstallationScriptInstallationTypeEnum = {
    INSTALLATION_TYPE_UNSPECIFIED: 'INSTALLATION_TYPE_UNSPECIFIED',
    IRSA_INSTALLATION: 'IRSA_INSTALLATION',
    NODE_ROLE_INSTALLATION: 'NODE_ROLE_INSTALLATION'
} as const;
export type EphemeralStorageAPIInstallationScriptInstallationTypeEnum = typeof EphemeralStorageAPIInstallationScriptInstallationTypeEnum[keyof typeof EphemeralStorageAPIInstallationScriptInstallationTypeEnum];
